/** Quiet scrollbars for panel scrollers: no painted track or corner (the
 * "rectangle" classic scrollbars draw against rounded panels), just a slim
 * rounded thumb. Standard properties carry Chrome/Firefox; the webkit rules
 * carry Safari (Chrome ≥121 ignores them once scrollbar-width is set). */
export const quietScrollbarStyles = {
    scrollbarWidth: 'thin',
    scrollbarColor: 'var(--chakra-colors-border) transparent',
    '&::-webkit-scrollbar': { width: '8px', height: '8px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-corner': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': {
        background: 'var(--chakra-colors-border)',
        borderRadius: '8px',
    },
} as const;

const HOVER_THUMB = 'var(--chakra-colors-border-emphasized)';
// Keyboard focus only (on the scroller or inside it): a clicked link keeps
// :focus-within after the pointer leaves and would pin the bar on.
const REVEAL = '&:hover, &:focus-visible, &:has(:focus-visible)';

/** A slim scrollbar shown only while the scroller is hovered or keyboard-
 * focused. Webkit rules force a classic bar (macOS overlay bars never show on hover;
 * Chrome ignores them if the standard props are set, hence Firefox-only).
 * The hover background is a repaint nudge: Chrome won't repaint the thumb
 * on a pseudo-only style change. */
export const hoverScrollbarStyles = {
    '&::-webkit-scrollbar': { width: '8px', height: '8px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-corner': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': {
        background: 'transparent',
        borderRadius: '8px',
    },
    [REVEAL]: {
        backgroundColor: 'rgb(0 0 0 / 0.001)',
    },
    '&:hover::-webkit-scrollbar-thumb, &:focus-visible::-webkit-scrollbar-thumb, &:has(:focus-visible)::-webkit-scrollbar-thumb':
        {
            background: HOVER_THUMB,
        },
    '@supports not selector(::-webkit-scrollbar)': {
        scrollbarWidth: 'thin',
        scrollbarColor: 'transparent transparent',
        [REVEAL]: {
            scrollbarColor: `${HOVER_THUMB} transparent`,
        },
    },
} as const;
